import { object, string } from "yup";
import SxForm from "../../../forms/SxForm";
import SxField from "../../../forms/fields/SxField";
import SubmitButton from "../../../components/SubmitButton";
import { authService } from "../../../services/auth/authService";
import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";

const CandidateRegisterForm = () => {
  const { register } = authService();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sponsorshipToken = searchParams.get("sponsorshipToken") ?? undefined;

  const initialValues = useMemo(() => {
    return {
      firstName: "",
      lastName: "",
      email: searchParams.get("email") ?? "",
      password: "",
      searchedPost: "",
      phoneNumber: "",
    };
  }, [searchParams]);

  const validationSchema = useMemo(() => {
    return object({
      firstName: string().label(t("auth:register.labels.FIRSTNAME")).required(),
      lastName: string().label(t("auth:register.labels.LASTNAME")).required(),
      email: string().email().label(t("auth:register.labels.EMAIL")).required(),
      password: string()
        .password()
        .label(t("auth:register.labels.PASSWORD"))
        .required(),
      phoneNumber: string().label(t("auth:register.labels.PHONE")),
      searchedPost: string()
        .label(t("auth:register.labels.SEARCHED_POST"))
        .required(),
    });
  }, []);

  return (
    <SxForm
      initialValues={initialValues}
      onSubmit={async (values) => {
        return register({
          firstname: values.firstName,
          lastname: values.lastName,
          email: values.email,
          password: values.password,
          phoneNumber: values.phoneNumber,
          positionInOrganization: null,
          searchedPost: values.searchedPost,
          sponsorshipToken,
        }).then(
          () => {
            // The sponsorship (if any) was already accepted server-side as
            // part of registration — no need to carry the token any further.
            navigate("/login");
          },
          () => {
            // do nothing
          },
        );
      }}
      validationSchema={validationSchema}
      enableReinitialize
    >
      <br />
      <SxField
        name="firstName"
        placeholder={t("register.placeholders.FIRSTNAME")}
      />
      <SxField
        name="lastName"
        placeholder={t("register.placeholders.LASTNAME")}
      />
      <SxField name="email" placeholder={t("register.placeholders.EMAIL")} />
      <SxField
        name="password"
        placeholder={t("register.placeholders.PASSWORD")}
      />
      <SxField
        name="searchedPost"
        placeholder={t("register.placeholders.SEARCHED_POST")}
      />
      <div className="cblock">
        <SxField
          name="phoneNumber"
          placeholder={t("register.placeholders.PHONE")}
        />
        <div className="input-tip">{t("register.user.PHONE_TIP")}</div>
      </div>

      <div className="lblock--l --txt--center">
        <SubmitButton type="submit" className="btn--1">
          {t("register.SIGN_UP")}
        </SubmitButton>
      </div>
    </SxForm>
  );
};

export default CandidateRegisterForm;
